import { EmptyState, PageHeader } from '@/components';
import { useAuth } from '@/features/auth/AuthProvider';
import { InviteUserForm } from '@/features/users/InviteUserForm';
import { useNavigate } from '@solidjs/router';
import { Show } from 'solid-js';

export default function AdminUserInvite() {
  const { session } = useAuth();
  const navigate = useNavigate();
  const canInvite = () => session()?.permissions.has('users:invite') ?? false;
  const done = () => navigate('/admin/users');

  return (
    <section>
      <PageHeader title="Invite user" />
      <div class="mx-auto max-w-6xl p-6">
        <Show
          when={canInvite()}
          fallback={
            <EmptyState
              variant="error"
              title="No permission"
              body="You don't have permission to invite users."
            />
          }
        >
          <div class="rounded-xl border border-neutral-100 bg-surface p-6 shadow-sm dark:border-neutral-800 dark:bg-surface-dark">
            <InviteUserForm onDone={done} onCancel={done} />
          </div>
        </Show>
      </div>
    </section>
  );
}
